<lib-announcement-banner
  [announcements]="unseenAnnouncements()"
  (closeAnnouncement)="onClose($event)"
></lib-announcement-banner>
